import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import styles from './Tooltip.scss'

const Tooltip = props => (
	<div styleName={
		cn({
			Tooltip: true,
			'Tooltip--visible': props.visible,
		})
	}>{props.children}</div>
)

Tooltip.propTypes = {
	children: PropTypes.any,
	visible: PropTypes.bool.isRequired,
}

Tooltip.defaultProps = {
	visible: false,
}

export default CSSModules(Tooltip, styles, { allowMultiple: true })
